import { ButtonGroup } from "@luciad/ria-sample-common/components/ButtonGroup";
import React from "react";
import { ChooseReferenceModal } from "../ogcapimaps/ChooseReferenceModal";
import { AddBingMapsModal } from "./AddBingMapsModal";
import { AddExampleDataModal } from "./AddExampleDataModal";
import { AddHereMapsModal } from "./AddHereMapsModal";
import { ButtonWithModal } from "./ButtonWithModal";
import { ConnectToModal } from "./ConnectToModal";
import { OpenFileModal } from "./OpenFileModal";

export const DataFormatsBottomBar = () => {
  return (
    <ButtonGroup>
      <ButtonWithModal label="Choose projection"
        modal={(show, onHide) => <ChooseReferenceModal show={show} onHide={onHide} />} />
      <ButtonWithModal label="Add example data"
        modal={(show, onHide) => <AddExampleDataModal show={show} onHide={onHide} />} />
      <ButtonWithModal label="Add Bing Maps"
        modal={(show, onHide) => <AddBingMapsModal show={show} onHide={onHide} />} />
      <ButtonWithModal label="Add HERE Maps"
        modal={(show, onHide) => <AddHereMapsModal show={show} onHide={onHide} />} />
      <ButtonWithModal label="Open file" modal={(show, onHide) => <OpenFileModal show={show} onHide={onHide} />} />
      <ButtonWithModal label="Connect to..." modal={(show, onHide) => <ConnectToModal show={show} onHide={onHide} />} />
    </ButtonGroup>
  );
}